module.exports = __webpack_public_path__ + "img/07.e6079a64.jpg";